export const TelemetrySortField = {
  Timestamp: "Timestamp",
  Method: "Method",
  Path: "Path",
  StatusCode: "StatusCode",
  DurationInMs: "DurationInMs",
  CustomerId: "CustomerId",
  ApiName: "ApiName",
  ClientIp: "ClientIp",
} as const;

export type TelemetrySortFieldType =
  (typeof TelemetrySortField)[keyof typeof TelemetrySortField];
